import React, { useState } from 'react';
import classNames from 'classnames';
import { Avatar, Chip, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var ListPinFilter = function (_a) {
    var icon = _a.icon, text = _a.text, onDisable = _a.onDisable, onMakeGlobal = _a.onMakeGlobal, onRemove = _a.onRemove, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var ChipAvatar = (React.createElement(Avatar, { className: classNames('pinFilter__avatar', { 'pinFilter__avatar--disabled': disabled }) },
        React.createElement(AccurityIcon, { iconName: icon, color: "white", fontSize: "small" })));
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var handleMakeGlobal = function (e) {
        handleMenuClose();
        onMakeGlobal === null || onMakeGlobal === void 0 ? void 0 : onMakeGlobal(e);
    };
    var handleEnableDisable = function (e) {
        handleMenuClose();
        onDisable === null || onDisable === void 0 ? void 0 : onDisable(e, !disabled);
    };
    var handleRemove = function (e) {
        handleMenuClose();
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(e);
    };
    return (React.createElement("div", { className: "pinFilter" },
        React.createElement(Chip, { onClick: function (e) { return setAnchorEl(e.currentTarget); }, label: text, avatar: ChipAvatar }),
        React.createElement(Menu, { open: !!anchorEl, anchorEl: anchorEl, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' }, onClose: handleMenuClose },
            onMakeGlobal && React.createElement(MenuItem, { onClick: handleMakeGlobal }, t('pinFilter.makeGlobal')),
            onDisable && React.createElement(MenuItem, { onClick: handleEnableDisable }, disabled ? t('pinFilter.enable') : t('pinFilter.disable')),
            onRemove && React.createElement(MenuItem, { onClick: handleRemove }, t('pinFilter.remove')))));
};
export default ListPinFilter;
//# sourceMappingURL=ListPinFilter.js.map